import { BankdataDisplayModel } from "@/api/model-index";
import { IbanValidator } from "../validators/iban-validator";

export function removeIbanFormatting(bankdata: BankdataDisplayModel | null | undefined): void {
  let formvalue = bankdata?.iban || '';
  if (formvalue && bankdata) {
    bankdata.iban = formvalue.replace(/\s/g, '');
  }
}

export function formatIban(iban: string | null): string {
  if (!iban) return '';
  return iban.toUpperCase().replace(/\s+/g, '').replace(/(.{4})/g, '$1 ').trim();
}

export function formatBic(bic: string | null): string {
  if (!bic) return '';
  return bic.toUpperCase().trim() || '';
}